import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $label': {
      color: TextColors.light,

      '&.has-no-values': {
        color: hexToRGBA(TextColors.light, TextOpacities.light3),
      },
    },
    '& $icon': {
      color: SecondaryColors.dark,
    },
  },
};

const lightTheme = {
  root: {
    '& $label': {
      color: TextColors.dark,

      '&.has-no-values': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
      },
    },
    '& $icon': {
      color: SecondaryColors.main,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,

      '& .filter-checkbox .MuiFormControlLabel-root': {
        marginLeft: 0,
      },
    },
    checkbox: {},
    label: {
      '& .MuiFormControlLabel-label': {
        alignItems: 'flex-start',
        flexGrow: 1,
        lineHeight: 'normal',
        marginTop: '7px',
        marginBottom: '7px',
      },
    },
    icon: {
      marginLeft: muiTheme.spacing(1.5),
    },
    partnerOnly: {
      marginLeft: muiTheme.spacing(0.7),
    },
    iconImage: {
      fontSize: '1.8rem',
    },
    inputWrapper: {
      flex: 1,
      position: 'relative',
      padding: muiTheme.spacing(0, 1.125, 2),
    },
  }),
  { name: 'GenElasticFacetFilters' },
);

export default useStyles;
